module.exports = __webpack_public_path__ + "static/media/therooms.f869430e.jpg";